import {CoreDI} from '@gongxigames/framework/core/configs';
import {UiServiceV2} from '@gongxigames/framework/slotV2/baseClasses/uiServiceV2/UIServiceV2';
import {SpecialInfoContainerProps, SpecialInfoZoneType} from '@gongxigames/framework/slotV2/services/SpecialInfoZone/types';
import {$SpecialInfoZoneContainer} from '@gongxigames/framework/slotV2/services/SpecialInfoZone/SpecialInfoZoneContainer';
import {Store} from '@gongxigames/framework/core';
import {specialInfoZonePositionLandscape, specialInfoZonePositionPortrait} from '@gongxigames/framework/slotV2/services/SpecialInfoZone/specialInfoZoneStore';
import {Container} from 'pixi.js';

export class SpecialInfoZoneService extends UiServiceV2 {
    public static NAME: symbol = CoreDI.SpecialInfoZoneService;

    // TODO put per UI
    private containersConfig: SpecialInfoContainerProps[] = [
        {
            id: 'MainJurisdictionZone',
            zOrder: 1,
            stickTo: 'bottom',
            orientation: 'portrait',
            xTranslate: Store.signal(0),
            yTranslate: Store.signal(0)
        },
        {
            id: 'AdditionalJurisdictionZone',
            zOrder: 0,
            stickTo: 'bottom',
            orientation: 'portrait',
            xTranslate: Store.signal(0),
            yTranslate: Store.signal(0)
        },
        {
            id: 'ButtonZone',
            zOrder: 1,
            stickTo: 'top',
            orientation: 'portrait',
            xTranslate: Store.signal(0),
            yTranslate: Store.signal(0)
        },
        {
            id: 'MainJurisdictionZone',
            zOrder: 1,
            stickTo: 'bottom',
            orientation: 'landscape',
            xTranslate: Store.signal(0),
            yTranslate: Store.signal(0)
        },
        {
            id: 'AdditionalJurisdictionZone',
            zOrder: 0,
            stickTo: 'bottom',
            orientation: 'landscape',
            xTranslate: Store.signal(0),
            yTranslate: Store.signal(0)
        },
        {
            id: 'ButtonZone',
            zOrder: 1,
            stickTo: 'top',
            orientation: 'landscape',
            xTranslate: Store.signal(0),
            yTranslate: Store.signal(0)
        }
    ];

    private zoneContainersGroups: SpecialInfoZoneType[][] = [];

    public onInit(): void {
        this.createSpecialZoneContainers();
    }

    public onSetupEvents(): void {
        this.emitter.on('UI.specialZone.relocate', () => {
            requestAnimationFrame(this.relocateZoneContainers.bind(this));
        });
    }

    protected createSpecialZoneContainers(): void {
        this.containersConfig.forEach((config) => {
            const container = $SpecialInfoZoneContainer(config) as Container;

            this.setAdditionalZonePosition(config);
            this.store.stage_rootContainer_ui.value.addChild(container);
            this.addToZoneContainers({...config, container});
        });
    }

    private setAdditionalZonePosition(config: SpecialInfoContainerProps): void {
        if (config.id === 'AdditionalJurisdictionZone') {
            if (config.orientation === 'portrait') {
                specialInfoZonePositionPortrait.value = config.stickTo;
            }

            if (config.orientation === 'landscape') {
                specialInfoZonePositionLandscape.value = config.stickTo;
            }
        }
    }

    private addToZoneContainers(zoneInfo: SpecialInfoZoneType): void {
        for (const zoneContainersGroup of this.zoneContainersGroups) {
            if (zoneContainersGroup[0] && zoneContainersGroup[0].stickTo === zoneInfo.stickTo && zoneContainersGroup[0].orientation === zoneInfo.orientation) {
                zoneContainersGroup.push(zoneInfo);
                zoneContainersGroup.sort((a, b) => b.zOrder - a.zOrder);

                return;
            }
        }
        this.zoneContainersGroups.push([zoneInfo]);
    }

    protected relocateZoneContainers(): void {
        this.zoneContainersGroups.forEach((zoneContainersGroup) => {
            let posY = 0;

            zoneContainersGroup.forEach((zoneInfo) => {
                if (zoneInfo.stickTo === 'top' || zoneInfo.stickTo === 'top-right' || zoneInfo.stickTo === 'top-left') {
                    zoneInfo.yTranslate.value = posY;
                } else if (zoneInfo.stickTo === 'bottom') {
                    zoneInfo.yTranslate.value = -posY - zoneInfo.container.height;
                }

                posY += zoneInfo.container.height;
            });
        });
    }
}